import MersenneTwister from "mersenne-twister";
export class SeededRandom {
    constructor(seed) {
        this.generator = new MersenneTwister();
        if (seed) {
            this.seed(seed);
        }
    }
    seed(seed) {
        this.generator.init_seed(seed);
    }
    random() {
        return this.generator.random();
    }
    randomInRange(min, max) {
        return Math.floor(this.random() * (max - min + 1)) + min;
    }
    pickFromArray(arr) {
        return arr[Math.floor(this.random() * arr.length)];
    }
    shuffle(array, inPlace = false) {
        let ret = inPlace ? array : array.slice();
        for (let i = ret.length - 1; i > 0; i--) {
            const j = Math.floor(this.random() * (i + 1));
            [ret[i], ret[j]] = [ret[j], ret[i]];
        }
        return ret;
    }
}
//# sourceMappingURL=SeededRandom.js.map